import { PureComponent } from 'react';

import {DesktopMenuIconComponentProps} from 'Component/DesktopMenuIcon/DesktopMenuIcon.type';
import { ReactElement } from 'Type/Common.type';

import './DesktopMenuIcon.style.scss';

/** @namespace Steinkrueger/Component/DesktopMenuIcon/Component */
export class DesktopMenuIconComponent extends PureComponent<DesktopMenuIconComponentProps> {
    static defaultProps: Partial<DesktopMenuIconComponentProps> = {
        isOpened: false,
    };

    render(): ReactElement {
        const { isOpened } = this.props;

        if (isOpened) {
            return (
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M15.6478 0.85199C15.1785 0.382671 14.4176 0.382669 13.9483
                      0.851989L7.99981 6.80047L2.05139 0.852051C1.58207 0.382732 0.821157
                      0.382732 0.351838 0.852051C-0.117482 1.32137 -0.117483 2.08229 0.351836
                      2.5516L6.30026 8.50003L0.351848 14.4484C-0.117471 14.9178 -0.117471
                      15.6787 0.351848 16.148C0.821167 16.6173 1.58208 16.6173 2.0514
                      16.148L7.99981 10.1996L13.9483 16.1481C14.4176 16.6174 15.1785 16.6174 15.6478
                      16.1481C16.1172 15.6787 16.1172 14.9178 15.6478 14.4485L9.69937 8.50003L15.6478
                      2.55155C16.1172 2.08223 16.1172 1.32131 15.6478 0.85199Z"
                      fill="white"
                    />
                </svg>

            );
        }

        return (
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.125 4.5H16.875"
                  stroke="white"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3.125 10.5H16.875"
                  stroke="white"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3.125 16.5H11.25"
                  stroke="white"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
            </svg>

        );
    }
}

export default DesktopMenuIconComponent;
